module.exports = __webpack_public_path__ + "img/file-invoice-solid updated.f0289705.svg";